import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import styled from 'styled-components';
import { DebounceInput } from 'react-debounce-input';
import { updateFilters } from '../../modules/clientModule/utils';
import { RootState } from '../../redux/root';
import { clearFilter } from '../../redux/slices/filterSlice';

type Props = {
  name: string;
  height?: string;
}
const SearchInput = ({ name, height = undefined }) => {
    const dispatch = useDispatch();
    const [value, setValue] = useState<string>();
    const filters = useSelector((s: RootState) => s.filters.filters);

    useEffect(() => {
      if (name && filters) {
        filters.forEach(f => {
          if (f.filterName === name) {
            setValue(f.filterValue);
          }
        });
      }
    }, []);
    const removeFilterClick = (name, value) => {
      dispatch(clearFilter(name));
      setValue('');
    };

    const doFilter = (name, value) => {
      updateFilters(name, value, filters, dispatch);
      setValue(value);
    };
    return (
      <Search height={height}>
        <DebounceInput name={name} value={value} debounceTimeout={1000} onChange={e => doFilter(name, e.target.value)} />
        <IconButton>
          {value ? <CloseIcon onClick={e => removeFilterClick(name, value)} /> : <SearchIcon />}
        </IconButton>
      </Search>
    );
};

export default SearchInput;

const IconButton = styled.div`
  display: inline-flex;
  align-items: center;
  padding-right: 8px;
  color: var(--neutral-400);
  svg {
    font-size: 1rem;
    cursor: pointer;
    transition: color 0.15s ease;
  }
  svg:hover {
    color: var(--neutral-600);
  }
`;

const Search = styled.div<{height?: string}>`
  display: flex;
  align-items: center;
  border: 1px solid var(--border);
  border-radius: 8px;
  height: ${({ height }) => height || '30px'};
  background-color: var(--neutral-0);
  margin: 8px 10px 10px;
  min-width: 0;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    border-color: var(--neutral-400);
  }

  &:focus-within {
    border-color: var(--primary-600);
    box-shadow: var(--shadow-focus);
  }

  input {
    flex: 1;
    min-width: 0;
    height: 100%;
    outline: none;
    border: none;
    background: transparent;
    padding: 0 8px 0 12px;
    font-family: inherit;
    font-size: 0.8125rem;
    color: var(--mainText);
    &::placeholder {
      color: var(--neutral-400);
    }
  }
`;
